import { injectCpmsBoTransactionReportsDurationStatisticsApi } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/cpms-bo-transaction-reports-duration-statistics.service';

import { baseApi } from '@service/base-api.service';

export const cpmsBoTransactionReportsDurationStatisticsApi =
  injectCpmsBoTransactionReportsDurationStatisticsApi(baseApi);

export const {
  useCpmsBoGetDurationByLocationQuery,
  useCpmsBoGetDurationByThirdPartyEndpointQuery,
  useCpmsBoGetDurationByChargePointQuery,
  useCpmsBoGetDurationByDayQuery,
  useCpmsBoGetDurationByMonthQuery,
  useCpmsBoGetDurationByYearQuery,
  useCpmsBoGetDurationQuery,
} = cpmsBoTransactionReportsDurationStatisticsApi;
